import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  /* Above the reconnect toast (z-index 1500) so it fully blocks the app. */
  z-index: 2000;
  background: linear-gradient(180deg, #161d25 0%, #070c12 100%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

export const Title = styled.div`
  width: 450px;
  max-width: 90vw;
  color: #fff;
  font-family: inherit;
  font-size: 26px;
  text-align: center;
  line-height: 1.1;
`;

export const Message = styled.div`
  width: 480px;
  max-width: 90vw;
  margin-top: 16px;
  color: #c5ccd6;
  font-family: inherit;
  font-size: 16px;
  text-align: center;
  line-height: 1.4;
  /* Preserve newlines from the Harness treatment config message. */
  white-space: pre-line;
`;
